import { DOCUMENT, inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

// For panel paths whose content lives on another site: `replace` keeps the panel URL out of the
// history, so the browser's back button does not bounce the visitor straight into the redirect again.
export function externalRedirectGuard(url: string): CanActivateFn {
  return () => {
    inject(DOCUMENT).location.replace(url);
    return false;
  };
}
